module.exports = __webpack_public_path__ + "img/canvasMenu10_paste.cb782e7a.svg";